<template lang="pug">
    div( class="main-page d-flex")
        v-navigation-drawer(permanent style="width:220px; min-width:220px; padding: 0 8px;" class="main-sidebar blue8")

            //- Home
            router-link(:to="{name: 'landing-page.home'}" )
                div(class="v-list-item v-list-non-sub-item" style="border: 0px solid red" id="homeElement"
                        :class="otherMenuItemSelected('home') ? 'highlighted-background highlighted-right-border' : ''"
                        @click="setActiveMenuItem('home'), setShowUserAccountMenu(false)")
                    v-list-item-icon(class="my-0" style="border:0px solid")
                        v-icon(:class="otherMenuItemSelected('home') ? 'highlighted-background' : ''") mdi-home-outline
                    v-list-item-title(style="border:0px solid;") {{ $t('home') }}

            //- Dashboard
            router-link(v-if="user.access==='admin'" :to="{name: 'landing-page.dashboard'}" )
                div(class="v-list-item v-list-non-sub-item mb-1 mt-2"
                        :class="otherMenuItemSelected('dashboard') ? 'highlighted-background highlighted-right-border' : ''"
                        @click="setActiveMenuItem('dashboard'), setShowUserAccountMenu(false)")
                    v-list-item-icon(class="my-0" style="border:0px solid;")
                        v-icon(:class="otherMenuItemSelected('dashboard') ? 'highlighted-background' : ''") mdi-view-dashboard
                    v-list-item-title(style="border:0px solid;") Dashboard




            //- Recents, last 8
            div(id="recentContainer" class="v-list-item v-list-non-sub-item" style="border: 0px solid red; flex-wrap: wrap")
                div(style="display: flex; width: 100%")
                    v-list-item-icon(class="my-0")
                        v-icon mdi-history
                    v-list-item-title {{ $t('Recent') }}

                <!--:key="recent"-->
                v-list-item(v-for="(recent) in recents"
                    @click="setActiveMenuItem(), setShowUserAccountMenu(false)"
                    class="recent-list-item"
                    :id="'stock-' + recent"
                    style=""
                )
                    div(style="border:0px solid; display: flex; width: 100%; justify-content: space-between; padding: 4px;")
                        Ticker(:stockId="recent")
                        div(
                            style="position:relative;"
                            @mouseover="hoverEffect = true"
                            @mouseout="hoverEffect = false")
                            router-link(:to="{name: 'landing-page.stock-detail', params: {stock_id: recent}}" style="")
                                v-icon(class="vv" size="19" ) home

                            router-link(:to="{name: 'landing-page.stock-detail', params: {stock_id: recent}, query: {tab: 1}}" style="")
                                v-icon(class="vv ml-1 " size="17") mdi-file-document

                            router-link(:to="{name: 'landing-page.stock-detail', params: {stock_id: recent}, query: {tab: 2}}" style="")
                                v-icon(class="vv ml-1" size="17") mdi-chart-line

            //- Watchlists
            div( class="mb-1" style="position:relative;border:0px solid; flex-wrap:wrap;")
                router-link( :to="{name: 'landing-page.watchlist'}")
                    div(:id="'watchlist'" :class="otherMenuItemSelected('watchlist') ? 'highlighted-background highlighted-right-border' : ''"
                        @click="setActiveMenuItem('watchlist'), setShowUserAccountMenu(false)"
                        class="v-list-item v-list-non-sub-item cursor-pointer v-list-item--link")
                        v-list-item-icon(class="my-0")
                            v-icon(:class="otherMenuItemSelected('watchlist') ? 'highlighted-background' : ''") mdi-eye-outline
                        v-list-item-title {{ $t('Watchlists') }}
                        div(class="left-nav-add-btn")
                            button(@click="addWatchlist()" class="") + {{ $t('Add') }}

                div(class="row-editable" v-for="(wl, index) in watchlists"
                    @click="setActiveWatchlistSubMenuItem(index), setShowUserAccountMenu(false)"
                    @dragover="$store.commit('setIsDragged', index), $store.commit('setIsDraggedOverWatchlistItem', false)"
                    :class="($store.getters.getIsDragged === index) ? 'dashed-border' : checkWatchlistSubMenuActive(index) && watchlistSelected === null && preventHighligt ? 'highlighted-background highlighted-right-border' : ''"
                    style="position:relative; overflow:hidden;margin-left: 24px")
                    draggable(v-if="wl.watchlist_id !== watchlistSelected" group="watchlist" @start="drag=true" @end="false" style="position:relative;")
                        div(@click="routerLink(wl.watchlist_id, wl.name)" :id="'watchlist-' + wl.watchlist_id" :key="wl.watchlist_id" class="cursor-pointer ellipsis v-list-item" style="padding:5px 7px; border:0px solid;") {{ (wl.name === 'Visitor\'s List') ? $t('visitors_list') : wl.name }}
                        //- v-list-item(
                            :key="wl.watchlist_id"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                            style="width:100%;"
                            :id="'watchlist-' + wl.watchlist_id")
                            router-link( :to="{name: 'landing-page.watchlist-detail', params: {id: wl.watchlist_id}}"
                                style="width:100%;")
                                v-list-item-title( class="ellipsis" style="border:0px solid;") {{ wl.name }}
                    div(v-else class="ml-12" style="width:100%; border:0px solid;")
                        input(type="text" ref="textElement" v-model="editLinkText" @keyup.enter="saveWatchlistName(wl.watchlist_id)" @blur="saveWatchlistName(wl.watchlist_id)" style="background-color:white; width:153px; height:22px; border:1px solid;")
                    div(style="position:absolute; right:15px; top:4px; border:0px solid;")
                        v-icon(@click="editWatchlist(wl)" size="18" class="pencil" style="border:0px solid;")  mdi-grease-pencil

            //- Research
            router-link(:to="{name: 'landing-page.research'}")
                div(:id="'research'" :class="otherMenuItemSelected('research') ? 'highlighted-background highlighted-right-border' : ''"
                    @click="setActiveMenuItem('research'), setShowUserAccountMenu(false)"
                    class="v-list-item v-list-non-sub-item cursor-pointer")
                    v-list-item-icon(class="my-0")
                        //v-icon $research
                        v-icon(:class="otherMenuItemSelected('research') ? 'highlighted-background' : ''") mdi-star
                    v-list-item-title  {{ $t('research_analyser') }}

            //- News
            router-link(:to="{name: 'landing-page.news'}")
                div(:id="'news'" :class="otherMenuItemSelected('news') ? 'highlighted-background highlighted-right-border' : ''"
                    @click="setActiveMenuItem('news'), setShowUserAccountMenu(false)"
                    class="v-list-item v-list-non-sub-item cursor-pointer")
                    v-list-item-icon(class="my-0")
                        v-icon(:class="otherMenuItemSelected('news') ? 'highlighted-background' : ''") mdi-web
                    v-list-item-title  {{ $t('news') }}

            //- Screener v2
            div(@click="defaultSortOfScreenerColumns()" :id="'screener'" :class="otherMenuItemSelected('screener') ? 'highlighted-background highlighted-right-border' : 'not-highlighted-right-border'"
                class="v-list-item v-list-non-sub-item cursor-pointer" style="border:0px solid; display:block")
                div(style="position:relative; border:0px solid red; width:100%")
                    router-link(:to="{name: 'landing-page.screener-detail', params: {id: 0}}" style="display:flex")
                        v-list-item-icon(@click="setActiveMenuItem('screener'), setShowUserAccountMenu(false)" style="margin-top:0px; border:0px solid;")
                            v-icon(:class="otherMenuItemSelected('screener') ? 'highlighted-background' : ''") mdi-target
                        v-list-item-title(@click="setActiveMenuItem('screener'), setShowUserAccountMenu(false)" id="screenerLinkSelector" :class="otherMenuItemSelected('screener') ? 'highlighted-background' : ''" style="border:0px solid;") {{ $t('Screen') }}
                div(class="left-nav-add-btn")
                    button(@click="addScreener()" class="") + {{ $t('Add') }}

            div(v-for="(screener, index) in getUserScreenersOrderOnScreenId" :key="screener.screen_id" @click="specificSortOfScreenerColumns(screener.screen_id)" class="v-list-item row-editable" :class="checkScreenerSubMenuActive(index) ? 'highlighted-background highlighted-right-border' : ''" style="border:0px solid; padding:5px 7px; margin-left:25px")
                div(@click="setActiveScreenerSubMenuItem(index)" style="float:left; width:80%")
                    LeftMenuLink(:screen_id="screener.screen_id" :linkText="screener.name" :router="'landing-page.screener-detail'" :params="{id: screener.screen_id}")
                div(style="float:left; width:20%;text-align:center")
                    v-icon(@click="editScreener(screener)" size="18" class="pencil")  mdi-grease-pencil

            //- Text Search
            div(v-if="this.user.access === 'admin'")
                div(class="v-list-item v-list-non-sub-item mt-4")
                    v-list-item-icon(class="my-0")
                        v-icon mdi-magnify
                    v-list-item-title Full Text Search
                div(style="color:#999999; margin-left:40px; margin-bottom:10px;")
                    input(@keyup.enter="searchTextGo(), setShowUserAccountMenu(false)"
                        label="Search"
                        v-model="searchString"
                        style="border:1px #aaaaaa solid; border-radius:3px; background-color:white;margin-top:0;padding:1px 4px;"
                        class="ml-1")
                    div(class="mx-2") saas, supply chain, Q3, ränta, ARPU, Löfven, Retail, 5G

            //- Portfolio
            div(v-if="this.user.access === 'admin' || this.user.access === 'vip'" class="mb-0")
                div( class="mb-1")
                    router-link( :to="{name: 'landing-page.plan'}")
                        div(:id="'plan'" :class="otherMenuItemSelected('plan') ? 'highlighted-background highlighted-right-border' : ''"
                            @click="setActiveMenuItem('plan'), setShowUserAccountMenu(false)"
                            class="v-list-item v-list-non-sub-item cursor-pointer v-list-item--link")
                            v-list-item-icon(class="my-0")
                                v-icon(:class="otherMenuItemSelected('plan') ? 'highlighted-background' : ''") mdi-currency-usd
                            v-list-item-title Portfolio

                div
                    //- router-link( :to="{name: 'landing-page.plan'}")
                        v-list-item(
                            @click="setActiveDecidedSubMenuItem(1), setShowUserAccountMenu(false)"
                            :class="checkDecidedSubMenuActive(1) ? 'highlighted-background highlighted-right-border' : ''"
                            key="plan"
                            id="plan"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                        )
                            v-list-item-title( class="blue1--text")  Portfolio Plan

                    router-link( :to="{name: 'landing-page.transactionTabs'}")
                        v-list-item(
                            @click="setActiveDecidedSubMenuItem(2)"
                            :class="checkDecidedSubMenuActive(2) ? 'highlighted-background highlighted-right-border' : ''"
                            key="transactionTabs"
                            id="transactionTabs"
                            class="cursor-pointer v-list-item--link v-list-sub-item mt-1"
                        )
                            v-list-item-title( class="blue1--text")  Transactions

                    router-link( :to="{name: 'landing-page.positions'}")
                        v-list-item(
                            @click="setActiveDecidedSubMenuItem(3)"
                            :class="checkDecidedSubMenuActive(3) ? 'highlighted-background highlighted-right-border' : ''"
                            key="positions"
                            id="positions"
                            class="cursor-pointer v-list-item--link v-list-sub-item mt-1"
                        )
                            v-list-item-title( class="blue1--text")  Positions

                    router-link( :to="{name: 'landing-page.performance'}")
                        v-list-item(
                            @click="setActiveDecidedSubMenuItem(4)"
                            :class="checkDecidedSubMenuActive(4) ? 'highlighted-background highlighted-right-border' : ''"
                            key="performance"
                            id="performance"
                            class="cursor-pointer v-list-item--link v-list-sub-item mt-1"
                        )
                            v-list-item-title( class="blue1--text")  Performance

            //- Competitions
            template(v-if="userCompetitions.length > 0")
                //- div(v-if="this.user.access === 'admin' || this.user.access === 'vip'" id="competitionContainer" class="mb-0 mt-3")
                div(id="competitionContainer" class="mb-0 mt-3")
                    div( class="v-list-item v-list-non-sub-item")
                        v-list-item-icon(class="my-0")
                            v-icon $trophy
                        v-list-item-title  {{ $t('competitions') }}

                    div(v-for="(competition, index) in userCompetitions")
                        v-list-item(
                            @click="setActiveCompetitionItem(`competitionPlan${index}`), navigate('competitionPlan', competition.competition_id)"
                            :class="checkCompetitionMenuActive(`competitionPlan${index}`) ? 'highlighted-background highlighted-right-border' : ''"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                        )
                            v-list-item-title( class="blue1--text")
                                span(v-html="competition.svg_icon")
                                span &nbsp;{{ competition.title }}
                        v-list-item(
                            @click="setActiveCompetitionItem(`competitionTransactions${index}`), navigate('competitionTransactions', competition.competition_id)"
                            :class="checkCompetitionMenuActive(`competitionTransactions${index}`) ? 'highlighted-background highlighted-right-border' : ''"
                            :id="`competitionTransactions${competition.competition_id}`"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                        )
                            v-list-item-title(class="ml-15 blue1--text" ) {{ $t('transactions') }}
                        v-list-item(
                            @click="setActiveCompetitionItem(`competitionPositions${index}`), navigate('competitionPositions', competition.competition_id)"
                            :class="checkCompetitionMenuActive(`competitionPositions${index}`) ? 'highlighted-background highlighted-right-border' : ''"
                            :id="`competitionPositions${competition.competition_id}`"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                        )
                            v-list-item-title(class="ml-15 mt-1 blue1--text" ) {{ $t('positions') }}
                        //- v-list-item(
                        //-     @click="setActiveCompetitionItem(`competitionPerformance${index}`), navigate('competitionPerformance', competition.competition_id)"
                        //-     :class="checkCompetitionMenuActive(`competitionPerformance${index}`) ? 'highlighted-background highlighted-right-border' : ''"
                        //-     class="cursor-pointer v-list-item--link v-list-sub-item"
                        //- )
                        //-     v-list-item-title(class="ml-15 mt-1 mb-3 blue1--text" ) Performance

            //- Backoffice
            div(v-if="this.user.access === 'admin'")
                div( class="v-list-item v-list-non-sub-item")
                    v-list-item-icon(class="mt-2 mb-2")
                        v-icon mdi-chart-bar
                    v-list-item-title Backoffice
                div
                    router-link( :to="{name: 'landing-page.backofficeUsers'}")
                        v-list-item(
                            @click="setActiveDecidedSubMenuItem(5), setShowUserAccountMenu(false)"
                            :class="checkDecidedSubMenuActive(5) ? 'highlighted-background highlighted-right-border' : ''"
                            key="backofficeUsers"
                            id="backofficeUsers"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                        )
                            v-list-item-title( class="blue1--text") Users

                    router-link( :to="{name: 'landing-page.backofficeCalendar'}")
                        v-list-item(
                            @click="setActiveDecidedSubMenuItem(9), setShowUserAccountMenu(false)"
                            :class="checkDecidedSubMenuActive(9) ? 'highlighted-background highlighted-right-border' : ''"
                            key="backofficeCalendar"
                            id="backofficeCalendar"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                        )
                            v-list-item-title( class="blue1--text") Financial Calendars

                    router-link( :to="{name: 'landing-page.backofficeCompanies'}")
                        v-list-item(
                            @click="setActiveDecidedSubMenuItem(6), setShowUserAccountMenu(false)"
                            :class="checkDecidedSubMenuActive(6) ? 'highlighted-background highlighted-right-border' : ''"
                            key="backofficeCompanies"
                            id="backofficeCompanies"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                        )
                            v-list-item-title( class="blue1--text") Companies

                    router-link( :to="{name: 'landing-page.vuexViewer'}")
                        v-list-item(
                            @click="setActiveDecidedSubMenuItem(7), setShowUserAccountMenu(false)"
                            :class="checkDecidedSubMenuActive(7) ? 'highlighted-background highlighted-right-border' : ''"
                            key="vuexViewer"
                            id="vuexViewer"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                        )
                            v-list-item-title( class="blue1--text") VUEX

                    router-link( :to="{name: 'landing-page.logViewer'}")
                        v-list-item(
                            @click="setActiveDecidedSubMenuItem(8), setShowUserAccountMenu(false)"
                            :class="checkDecidedSubMenuActive(8) ? 'highlighted-background highlighted-right-border' : ''"
                            key="backofficeUsers"
                            id="backofficeUsers"
                            class="cursor-pointer v-list-item--link v-list-sub-item"
                        )
                            v-list-item-title( class="blue1--text") Health Check Log

        div( class="main-section")
            router-view

        EditScreenerSettings(
            :showEditScreenerPopup="showEditScreenerPopup"
            :screener="screener"
            @closeEditScreenerPopup="closeEditScreenerPopup"
        )

        EditWatchlistSettings(
            :showEditWatchlistPopup="showEditWatchlistPopup"
            :watchlist="watchlist"
            @closeEditWatchlistPopup="closeEditWatchlistPopup"
        )
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import draggable from "vuedraggable";
import Ticker from "./Ticker.vue";
import LeftMenuLink from "./LeftMenuLink.vue";
import EditScreenerSettings from "./EditScreenerSettings";
import EditWatchlistSettings from "./EditWatchlistSettings";
import _ from "lodash";

export default {
    components: {
        draggable,
        Ticker,
        LeftMenuLink,
        EditScreenerSettings,
        EditWatchlistSettings
    },
    data() {
        return {
            editLinkText: '',
            watchlistSelected: null,
            doubleClickCheck: 0,
            notEditText: true,
            windowHeight: 0,
            hoverEffect: false,
            activeMenuItem: 'home',
            searchString: '',
            clickedWatchlist: null,
            clickedScreener: null,
            clickedOther: null,
            clickedCompetition: null,
            screener: null,
            watchlist: null,
            showEditScreenerPopup: false,
            showEditWatchlistPopup: false,
            preventHighligt: true
        }
    },
    mounted() {
        this.windowHeight = window.innerHeight;
        window.addEventListener('resize', this.setWindowHeight);
    },
    created: async function () {
        this.user = JSON.parse(localStorage.user);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setWindowHeight);
    },
    methods: {
        ...mapActions([
            "loadUserTabs",
            "loadUserScreeners",
            "loadUserWatchLists",
            "newUserScreenerFilters",
            "insertWatchlist",
            "changeWatchlistName"
        ]),
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows',
            'setOrderOfColumns'
        ]),
        defaultSortOfScreenerColumns() {
            this.setOrderOfColumns(['sales_growth', 'ps', 'pe', 'stock_exchange_id', 'sector_id', 'sales', 'name', 'ticker']);
        },
        specificSortOfScreenerColumns(screen_id) {
            const screenColumnOrder = JSON.parse(this.getUserScreeners.find((us) => us.screen_id === screen_id).column_order);

            this.setOrderOfColumns(screenColumnOrder);
        },
        closeEditScreenerPopup() {
            this.showEditScreenerPopup = false;
        },
        closeEditWatchlistPopup() {
            this.showEditWatchlistPopup = false;
        },
        async saveWatchlistName(watchlist_id) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const watchlistObject = {
                user_id: this.user_id,
                name: this.editLinkText,
                watchlist_id: watchlist_id
            };

            await this.changeWatchlistName(watchlistObject);

            this.watchlistSelected = null;
        },
        routerLink(watchlist_id, name) {
            this.doubleClickCheck += 1;

            if(this.doubleClickCheck > 1) {
                this.preventHighligt = false;
                this.watchlistSelected = watchlist_id;
                this.editLinkText = name;

                setTimeout(() => {
                    this.$refs.textElement[0].select();
                }, 100);

                this.doubleClickCheck = 0;
            }

            setTimeout(() => {
                if(this.doubleClickCheck === 1) {
                    this.preventHighligt = true;

                    this.$router.push({name: 'landing-page.watchlist-detail', params: {id: watchlist_id}});
                }

                this.doubleClickCheck = 0;
            }, 300);
        },
        async addWatchlist() {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            console.log('add watchlist');
            console.log(this.user_id);

            await this.loadUserWatchLists(this.user_id);

            console.log(JSON.parse(JSON.stringify(this.getWatchlists)));
            console.log(JSON.parse(JSON.stringify(this.getWatchlists.filter((w) => w.name.includes('New Watchlist')))));

            const getHigestNewWatchlist = this.getWatchlists.filter((w) => w.name.includes('New Watchlist'));
            const watchlistNumber = (getHigestNewWatchlist.length > 0) ? parseInt(_.maxBy(getHigestNewWatchlist, (o) => o.name).name.replace(/\D/g,'')) + 1 : 1;

            console.log(watchlistNumber);

            const watchlistObject = {
                user_id: this.user_id,
                name: `New Watchlist ${watchlistNumber}`
            };

            await this.insertWatchlist(watchlistObject);
        },
        editWatchlist(watchlist) {
            console.log('editWatchlist');

            this.watchlist = watchlist;
            this.showEditWatchlistPopup = false;
            this.preventHighligt = false;

            console.log(this.watchlist);

            setTimeout(() => {
                this.showEditWatchlistPopup = true;
            }, 50);
        },
        async addScreener() {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            console.log('add screen');
            console.log(this.user_id);

            await this.loadUserScreeners(this.user_id);

            console.log(JSON.parse(JSON.stringify(this.getUserScreeners)));
            console.log(JSON.parse(JSON.stringify(this.getUserScreeners.filter((s) => s.name.includes('New Screener')))));

            const getHigestNewScreener = this.getUserScreeners.filter((s) => s.name.includes('New Screener'));
            const screenNumber = (getHigestNewScreener.length > 0) ? parseInt(_.maxBy(getHigestNewScreener, (o) => o.name).name.replace(/\D/g,'')) + 1 : 1;

            console.log(screenNumber);

            const payload = {
                user_id: this.user_id,
                name: `New Screener ${screenNumber}`,
                filter: JSON.stringify({
                    ticker: '',
                    name: '',
                    sales: { displayOption: 'array' },
                    sector_id: [],
                    stock_exchange_id: ['35201', '35197', '35181', '29929', '4680264', '29930', '35235', '35182', '39890', '33187', '35262', '35183'],
                    pe: { displayOption: 'array' },
                    ps: { displayOption: 'number' },
                    sales_growth: { displayOption: 'number' }
                }),
                column_order: JSON.stringify(['sales_growth', 'ps', 'pe', 'stock_exchange_id', 'sector_id', 'sales', 'name', 'ticker'])
            };

            await this.newUserScreenerFilters(payload);

            console.log(this.getUserScreeners);
        },
        editScreener(screener) {
            this.screener = screener;
            this.showEditScreenerPopup = false;

            console.log(this.screener);

            setTimeout(() => {
                this.showEditScreenerPopup = true;
            }, 50);
        },
        navigate(routerName, competition_id) {
            this.$router.push({name: `landing-page.${routerName}`, params: {competition_id: competition_id}});
        },
        setShowUserAccountMenu(value) {
            this.$store.commit('setShowUserAccountMenu', value);
        },
        setActiveWatchlistSubMenuItem(index) {
            this.clickedWatchlist = index;
            this.clickedScreener = null;
            this.clickedCompetition = null;
        },
        setActiveScreenerSubMenuItem(index) {
            this.clickedWatchlist = null;
            this.clickedScreener = index;
            this.clickedCompetition = null;
        },
        checkWatchlistSubMenuActive(index) {
            return (
                this.clickedWatchlist === index &&
                this.clickedScreener === null &&
                this.clickedCompetition === null
            );
        },
        checkScreenerSubMenuActive(index) {
            return (
                this.clickedWatchlist === null &&
                this.clickedScreener === index &&
                this.clickedCompetition === null
            );
        },
        checkDecidedSubMenuActive(index) {
            return (
                this.clickedOther === index &&
                this.clickedWatchlist === null &&
                this.clickedScreener === null &&
                this.clickedCompetition === null
            );
        },
        checkCompetitionMenuActive(index) {
            return (
                this.clickedCompetition === index &&
                this.clickedWatchlist === null &&
                this.clickedScreener === null &&
                this.clickedOther === null
            );
        },
        setActiveMenuItem(item = null) {
            this.activeMenuItem = item;
            this.clickedWatchlist = null;
            this.clickedScreener = null;
            this.clickedOther = null;
            this.clickedCompetition = null;
        },
        otherMenuItemSelected(item) {
            return (
                this.activeMenuItem === item &&
                this.clickedWatchlist === null &&
                this.clickedScreener === null &&
                this.clickedOther === null &&
                this.clickedCompetition === null
            );
        },
        setActiveDecidedSubMenuItem(index) {
            this.clickedOther = index;
            this.clickedWatchlist = null;
            this.clickedScreener = null;
            this.clickedCompetition = null;
        },
        setActiveCompetitionItem(index) {
            this.clickedCompetition = index;
            this.clickedWatchlist = null;
            this.clickedScreener = null;
            this.clickedOther = null;
        },
        searchTextGo() {
            if(this.searchString === '') {
                this.$store.commit('setMessage', { text: 'No text inserted yet...', type: 'error' });
                return;
            }

            this.$router.push({name: 'landing-page.textSearch'}).catch(()=>{});

            const textSearchInterval = setInterval(() => {
                if (typeof this.$children[1].search === 'function') {
                    this.$children[1].search(this.searchString);
                    clearInterval(textSearchInterval);
                }
            }, 50);
        },
        setWindowHeight() {
            this.windowHeight = window.innerHeight;
        },
        isPdfReportsTableLoaded() {
            this.$store.commit('setIsPdfReportsTableLoaded', 0);

            setTimeout(() => {
                this.$store.commit('setIsPdfReportsTableLoaded', 1);
            }, 50);
        },
        slug(name) {
            return name.replace(/\s+/g, '-');
        },
        getTicker(stock_id) {
            const s = this.getMapStocks.find(s => s.stock_id == stock_id);
            if (!s) {
                return null;
            }

            return s.ticker;
        }
    },
    computed: {
        ...mapGetters([
            "getUserSettings",
            "getSelectedResearchTabIndex",
            "getRecents",
            "getWatchlists",
            "getMapStocks",
            "screenerFilters",
            "pageId",
            "getUserCurrentWatchlistId",
            "getUserCompetitions",
            "getUserScreeners"
        ]),
        recents() {
            return this.getRecents;
        },
        watchlists() {
            const sortedWatchlists = _.orderBy(this.getWatchlists, ['watchlist_id'], ['desc']);

            return sortedWatchlists;
        },
        userCompetitions() {
            const x = this.getUserCompetitions;
            // console.log('----------');
            // console.log(x);
            return x;
        },
        watchlistItems() {
            return tmpArrthis.getWatchlistItems;
        },
        screeners() {
            return this.screenerFilters.filter(filter => filter.screen_id > -1 && filter.name != "No name Screener, not saved");  // the screen_id of default screener is -1.
        },
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        },
        getUserScreenersOrderOnScreenId() {
            return _.orderBy(this.getUserScreeners, (o) => o.screen_id);
        }
    }
}
</script>

<style scoped>

.left-nav-add-btn {
    border: 1px solid rgba(20, 75, 77, 1);
    border-radius: 4px;
    color: #404040;
    position: absolute;
    top: 7px;
    right: 6px;
    height: 17px;
    padding: 0 2px;
    -width: 40px;
    text-align: center;
    font-size: 9px;
    line-height: 1.8;
}

.highlighted-background .left-nav-add-btn {
    border-color: #fff;
    color: #fff;
}

.left-nav-add-btn button {
    text-transform: uppercase;
}

.pointer-cursor {
    cursor: pointer;
}

.main-page {
    padding: 20px 0 0;
}

.dashed-border {
    border: 1px dashed;
}

.vv {
    color: #94A6B8;
}
.v-icon:hover {
    cursor: pointer;
    color: #46638a;
}

.hoverEffect {
    cursor: pointer;
    color: #5887b9;
}

.main-section {
    width: 100%;
}

.side-section, .main-section {
    /*min-height: calc(100vh - 98px);*/
}


.v-list-item {
    padding: 6px;
}

.v-list-item .v-list-item {
    padding: 0;
}

.theme--light.v-list-item:hover:before {
    opacity: 0;
}

.v-list-item i.v-icon {
    font-size: 19px;
}

.v-application--is-ltr .v-list-item__icon:first-child {
    margin: 0;
}


.v-list-item.v-list-non-sub-item .v-list-item__title {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
}

.v-list-item.v-list-sub-item .v-list-item__title {
    font-size: 12px;
    font-weight: 200;
    margin-left: 24px;
    line-height: 1.3;
}

.v-list-item {
    min-height: 10px !important;
}

.v-list-item .v-list-item__title {
    color: #404040;
}

.highlighted-background .v-list-item__title {
    color: #fff;
}

.v-list-item.active .mdi:before {
    color: #587cd9;
}

.v-list-item.active .v-list-item__title {
    color: #587cd9;
}

.v-list-item .ticker {
    padding: 0px !important;
    margin: 0px !important;
}

.v-list-item.ticker-active .ticker {
    color: #58d2d2;
}

.v-list-item a {
    color: #000000;
}

.recent-list-item {
    margin-left: 21px;
}

>>>#recentContainer > div:first-child {
    margin-bottom: 8px;
}



.sticker {
    padding: 2px 16px 0 16px;
    background: #EBE6BD;
    font-size: 1.1rem;
    font-family: "Rockwell";
    transform: rotate(-10deg);
    border: 1px solid #888888;
    border-radius: 6px;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);

}

.highlighted-background {
    color: #fff;
    background-color: #144B4D;
    border-radius: 4px;
}

.highlighted-right-border {

}

.not-highlighted-right-border {

}

.row-editable {
    cursor: pointer;
}

.row-editable.highlighted-background .pencil {
    color: #fff;
}

.pencil {
    opacity: 0;
}

.row-editable:hover .pencil {
    opacity: 1;
}

>>>.main-sidebar a {
    font-size: 12px;
}
</style>
